module.exports = __webpack_public_path__ + "static/fonts/notokr-medium.81bd542.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/survey2/font/notokr-medium.woff
// module id = UaMU
// module chunks = 0